import React, { useContext } from "react";
import styled from "styled-components";

import {
  handlePlayPause,
  handleNext,
  handlePrev,
  handleSeek,
} from "../actions";
import { PlayerStateContext } from "../../../provider";
import ProgressBar from "./progress-bar";
import VolumeSlider from "./volume";

import { Box, Row, Col, FontIcon, Img, Text } from "../../../comps";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPauseCircle } from "@fortawesome/free-regular-svg-icons";
import { defaultVideoArt } from "../../../theme/image";
import {
  faStepBackward,
  faStepForward,
  faPlayCircle,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";

import { NAVBAR } from "../../../theme/dimensions";

const Wrapper = styled(Box)`
  width: 100%;
  height: 100%;
  padding-left: 3%;
  padding-right: 3%;
  align-items: center;
  background: ${({ theme, fullScreen }) =>
    theme.color.BLUE_4 + (fullScreen ? "a9" : "ff")};
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
  transition: height 1000ms ease;
`;

const Content = styled(Row)`
  width: 100%;
  height: 100%;
  align-items: center;
`;

const Thumbnail = styled(Img)`
  position: absolute;
  bottom: 0px;
  left: 0px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
`;

const ThumbnailWrapper = styled(Box)`
  position: relative;
  width: ${({ width }) => width + "px"};
  /* image inside the wrapper will be lifted (x/2)% if height is x% */
  height: 70%;
  cursor: pointer;
`;

const Details = styled(Col)`
  width: 20%;
  padding-left: 3%;
  padding-right: 2%;
  cursor: pointer;
`;

const ProgressBarWrapper = styled(Box)`
  flex-grow: 1;
  width: auto;
`;

export default ({ togglePlayerView, fullScreen }) => {
  const [playerState] = useContext(PlayerStateContext);
  const {
    isPlaying,
    title,
    playbackCovered,
    playbackLength,
    thumbnail,
    time,
    volume,
  } = playerState;
  const thumbnailHeight = 80,
    thumbnailWidth = (16 * thumbnailHeight) / 9.0;

  return (
    <Wrapper fullScreen={fullScreen}>
      <Content>
        <ThumbnailWrapper width={thumbnailWidth} onClick={togglePlayerView}>
          <Thumbnail
            width={thumbnailWidth}
            height={thumbnailHeight}
            src={thumbnail || defaultVideoArt}
          />
        </ThumbnailWrapper>
        <Details>
          <Text
            oneline={true}
            fontSize={`20px`}
            fontWeight={`10`}
            onClick={togglePlayerView}
          >
            {title}
          </Text>
        </Details>
        {/* Previous button */}
        <MaterialIconButton onClick={handlePrev}>
          <FontIcon fontSize={18 + "px"} color={`#fff`}>
            <FontAwesomeIcon icon={faStepBackward} />
          </FontIcon>
        </MaterialIconButton>
        {/* playPause button */}
        <MaterialIconButton onClick={handlePlayPause}>
          <FontIcon fontSize={32 + "px"} color={`#fff`}>
            <FontAwesomeIcon icon={isPlaying ? faPauseCircle : faPlayCircle} />
          </FontIcon>
        </MaterialIconButton>
        {/* Next button */}
        <MaterialIconButton onClick={handleNext}>
          <FontIcon fontSize={18 + "px"} color={`#fff`}>
            <FontAwesomeIcon icon={faStepForward} />
          </FontIcon>
        </MaterialIconButton>
        {/* playback */}
        <Box style={{ width: "auto", flexGrow: 1 }}>
          <ProgressBar
            isPlaying={isPlaying && time}
            playbackCovered={playbackCovered}
            playbackLength={playbackLength}
            seeker={handleSeek}
            time={time}
          />
        </Box>
        {/* Volume button and slider */}
        <VolumeSlider volume={volume} />
        {/* queue button : opens player sheet */}
        <MaterialIconButton onClick={togglePlayerView}>
          <FontIcon fontSize={18 + "px"} color={`#fff`}>
            <FontAwesomeIcon icon={faListUl} />
          </FontIcon>
        </MaterialIconButton>
      </Content>
    </Wrapper>
  );
};
